import { IPlayer, PlayerState } from "./abstraction/IPlayer";


export class AudioPlayer implements IPlayer {

    protected _ctx: AudioContext;
    protected _audio: HTMLAudioElement;

    constructor() {


    }

    loadAsync(src: string) {

        this._ctx = new AudioContext();

        this._audio = new Audio();
        this._audio.preload = "auto";
        this._audio.src = src;
        this._audio.volume = 0.5;
        this._audio.load = () => {
            console.log("laoded");
        }

        const source = this._ctx.createMediaElementSource(this._audio);

        source.connect(this._ctx.destination);
    }

    close() {
        if (!this._ctx)
            return;
        
        this._ctx.close();
        this._ctx = null;
    }

    playAsync(): Promise<void> {
        this._audio.play();
        return Promise.resolve();
    }

    pauseAsync(): Promise<void> {
        this._audio.pause();
        return Promise.resolve();
    }

    stopAsync(): Promise<void> {
        this._audio.pause();
        this._audio.currentTime = 0;
        return Promise.resolve();
    }

    setPositionAsync(posSec: number): Promise<void> {
        if (!Number.isFinite(posSec))
            return;
        this._audio.currentTime = posSec;

        return Promise.resolve();
    }

    get state() : PlayerState {
        if (!this._ctx)
            return "empty";
        if (this._audio.paused)
            return "pause";
        
        return "play";
    }

    get position() {
        return this._audio.currentTime;
    }

    
}